/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AcloperationAo } from '../../models/acloperation-ao';

export interface GetAllAclOperations$Params {
}

export function getAllAclOperations(http: HttpClient, rootUrl: string, params?: GetAllAclOperations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AcloperationAo>>> {
  const rb = new RequestBuilder(rootUrl, getAllAclOperations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AcloperationAo>>;
    })
  );
}

getAllAclOperations.PATH = '/api/AclRole/aclOperations';
